<template>
  <div data-component-group="filter-forms" data-component="reports-cpm">
    <FiltersForm
      :has-filters="hasFilters"
      :is-skeleton-loading="isSkeletonLoading"
      :is-global-country-filter="false"
      @filter="onFilter"
      @clear="onClearFilters"
    >
      <!--TODO drop on refactoring-->
      <template v-if="false">
        <v-autocomplete
          clearable
          v-model="business"
          :items="businesses"
          :loading="isLoadingBusinesses"
          prepend-inner-icon="home"
          :return-object="true"
          item-title="name"
          item-value="id"
          :label="$t('business')"
          v-model:search="businessSearch"
        />

        <v-autocomplete
          clearable
          v-model="merchant"
          :items="merchants"
          :loading="isLoadingMerchants"
          prepend-inner-icon="person"
          :return-object="true"
          item-title="name"
          :label="$t('merchant')"
          :placeholder="$t('not_defined')"
          class="cpm-filter-merchant"
          v-model:search="merchantSearch"
        />
      </template>

      <base-date-picker
        :date="dates"
        :default-date="defaultDateRange"
        placeholder="Select date range"
        :config="dateConfig"
        :on-change="onChangeDate"
        :hasClear="false"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import { v1 as uuidv1 } from 'uuid';
  import { isEqual } from 'lodash-es';
  import FiltersForm from './FiltersBase';
  import {isNum, isStr, debounce} from '@/utils';
  import { inject } from 'vue';

  const debouncer = debounce({
    id: uuidv1(),
    timeout: 500
  });

  // TODO: Translate component

  export default {
    components: {
      FiltersForm,
    },
    props: {
      isSkeletonLoading: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default() {
          // return this.$t('reports');
          return inject('i18n').t('reports');
        },
      },
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        dates: this.setDefaultDateRange(),
        defaultDateRange: this.dates,
        dateConfig: {
          mode: 'range',
        },
        business: null,
        merchant: null,
        businessSearch: '',
        merchantSearch: '',
        isLoadingBusinesses: false,
        isLoadingMerchants: false,
        isRefreshingBusinesses: false,
        isRefreshingMerchants: false,
      };
    },
    computed: {
      businesses() {
        return this.$store.getters['businesses/items'];
      },
      merchants() {
        return this.$store.getters['pepper/merchants'];
      },
      hasFilters() {
        const { business = {}, dates, defaultDateRange, canSeeExtendedTable } = this;
        return canSeeExtendedTable
          ? dates.length > 0 && isNum(business?.id) && !isEqual( dates, defaultDateRange)
          : dates.length > 0 && !isEqual( dates, defaultDateRange);
      },
      canSeeExtendedTable() {
        return this.$ability.can('view', 'extended-cpm-reports');
      },
    },
    watch: {
      business() {
        this.isRefreshingBusinesses = true;
      },
      merchant() {
        this.isRefreshingMerchants = true;
      },
      businessSearch(nextSearch) {
        if (isStr(nextSearch)) {
          if (this.isRefreshingBusinesses) {
            this.isRefreshingBusinesses = false;
            return false;
          }
          debouncer(() => this.getBusinesses(nextSearch));
        }
      },
      merchantSearch(nextSearch) {
        if (isStr(nextSearch)) {
          if (this.isRefreshingMerchants) {
            this.isRefreshingMerchants = false;
            return false;
          }
          debouncer(() => this.getMerchants(nextSearch));
        }
      },
    },
    created() {
      const { canSeeExtendedTable, setDefaultDateRange, onFilter } = this;

      this.dates = setDefaultDateRange();
      this.defaultDateRange = this.dates;

      if (!canSeeExtendedTable) {
        onFilter();
      }
    },
    methods: {
      getBusinesses(search = '') {
        const query = {
          per_page: -1,
          search,
        };

        this.isLoadingBusinesses = true;

        return this.$store
          .dispatch('businesses/getItems', query)
          .then((res) => {
            this.isLoadingBusinesses = false;
            return res;
          })
          .catch((err) => {
            this.isLoadingBusinesses = false;
            return err;
          });
      },
      getMerchants(search = '') {
        const query = {
          search,
        };

        return this.$store.dispatch('pepper/getMerchants', query);
      },
      setDefaultDateRange() {
        const urlDateRange = this.getDateRange();
        const rangeStart = urlDateRange
          ? urlDateRange.from
          : this.$dayjs().startOf('month').format('YYYY-MM-DD');
        const rangeEnd = urlDateRange
          ? urlDateRange.to
          : this.$dayjs().endOf('month').format('YYYY-MM-DD');

        return `${rangeStart} - ${rangeEnd}`;
      },
      getDateRange() {
        const { date_range } = this.$route.query;
        let dateRange = false;

        if (date_range) {
          const isValidDate = (item) =>
            this.$dayjs(item, 'YYYY-MM-DD', true).isValid();
          const dateItems = date_range.split(' - ');

          if (isValidDate(dateItems[0]) && isValidDate(dateItems[1])) {
            dateRange = {
              from: dateItems[0],
              to: dateItems[1],
            };
          }
        }

        return dateRange;
      },
      onChangeDate(dates) {
        this.dates = dates;
      },
      onFilter() {
        let { business = null, merchant = null, dates } = this;
        dates = dates.split(' - ');
        const filters = isNum(business?.id)
          ? { business, merchant, dates }
          : { dates };

        this.$emit('filter', filters);
      },
      onClearFilters() {
        this.business = null;
        this.merchant = null;
        this.dates = this.setDefaultDateRange();
        this.defaultDateRange = this.dates;

        const { business, merchant, dates } = this;
        const filters = isNum(business?.id)
          ? { business, merchant, dates }
          : { dates };

        this.$emit('clearFilters', filters);
      },
    },
  };
</script>

<style lang="scss">

</style>
